/**
 * A B2B partner's lifecycle vocabulary (purchase `partners.status`).
 *
 * A LEAF subpath (`@puffin-core/status-taxonomy/partner-status`) that requires nothing. A browser bundle that
 * needs only this vocabulary imports it here: the package ROOT's generated ESM half re-exports the
 * whole CommonJS surface, so importing the root carries every other status table into the bundle
 * (the console's vendor-core chunk went over budget that way; TOOLING-AND-DOCS-GEMS, 2026-09-30).
 * `constants.js` re-exports these, so there is ONE definition and the root surface is unchanged.
 *
 * @module @puffin-core/status-taxonomy/partner-status
 */

'use strict';

/**
 * A B2B partner's lifecycle (purchase-api `PartnerService`). `pending` → `approved` ⇄ `suspended`;
 * `pending` → `rejected` (terminal for that application). Promoted here by UMB-001 lane SEC
 * (RULING 9, 3a): the domain enum lived only inside purchase-api's service, so purchase-web's admin
 * page spelled its own literals — and checked for `active`, a state the domain does not have, so the
 * Suspend action never rendered.
 */
const PARTNER_STATUS = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  SUSPENDED: 'suspended',
  REJECTED: 'rejected',
});

const PARTNER_STATUS_VALUES = Object.freeze(Object.values(PARTNER_STATUS));

module.exports = {
  PARTNER_STATUS,
  PARTNER_STATUS_VALUES,
};
